/* eslint-disable no-param-reassign */
/*
  Respectivos códigos para as mensagens
  0:Normal
  1:Sucesso
  2:Atenção
  3:Erro
*/

import Vue from 'vue';
import Vuex from 'vuex';
import api from '../api/index';

import general from './modules/general/index';
import config from './modules/config/index';
import login from './modules/login/index';
import files from './modules/files/index';
import admin from './modules/admin/index';
import user from './modules/user/index';
import professional from './modules/professional/index';
import affiliate from './modules/affiliate/index';
import client from './modules/client/index';
import balconista from './modules/balconista/index';
import gerente from './modules/gerente/index';
import shopkeeper from './modules/shopkeeper/index';
import representative from './modules/representative/index';
import quote from './modules/quote/index';
import banner from './modules/banner/index';
import partner from './modules/partner/index';
import journal from './modules/journal/index';
import imagem from './modules/imagem/index';
import integration from './modules/integration/index';
import webhook from './modules/webhook/index';

Vue.use(Vuex);

const baseURI = process.env.VUE_APP_API_URL;

const error401 = 'Request failed with status code 401';

function isValid(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export default new Vuex.Store({
  modules: {
    general,
    config,
    login,
    files,
    admin,
    user,
    professional,
    affiliate,
    client,
    shopkeeper,
    representative,
    quote,
    banner,
    partner,
    journal,
    imagem,
    integration,
    balconista,
    gerente,
    webhook,
  },
  state: {
    homeConteudo: null,
    comoParticiparConteudo: null,
    pesquisaItens: null,
    baseURI,
    loaderAction: false,
    notification: null,
    tipoNotification: 0,
    cliente: null,
    clientes: [],
    lojista: null,
    lojistas: [],
    showContact: [],
    representante: null,
    representantes: [],
    tipoUsuarios: [],
    tipoMedida: null,
    tipoMedidas: [],
    tipoProfissao: null,
    tipoProfissoes: [],
    estado: null,
    estados: [],
    cidade: null,
    cidades: [],
    dicas: [],
    dica: null,
    produtos: [],
    setLowestPrice: [],
    produto: null,
    produtoMarcas: [],
    produtoMarca: null,
    categoriasProduto: [],
    cotacoesSingleEnviadas: [],
    cotacoesSingleGanhas: [],
    cotacoesSingleFinalizadas: [],
    cotacoesSingleCancelar: [],
    cotacoesContagem: [],
    cotacoes: [],
    invoices: [],
    setValidation: [],
    cotacao: null,
    profissionais: [],
    profissional: null,
    profissionaisDestaques: [],
    informacaoUpload: null,
    mensagensCotacao: null,
    dadosUsuario: isValid(localStorage.getItem('dadosUsuario'))
      ? JSON.parse(localStorage.getItem('dadosUsuario'))
      : localStorage.clear(),
    token: localStorage.getItem('token'),
    contratosProfissionais: [],
    contratoProfissional: null,
    cotacoesAdministrador: [],
    planos: [],
    plano: null,
    segmentos: [],
    segmento: null,
    banners: [],
    banner: null,
    usuarios: [],
    usuario: null,
    professionalPlans: [],
    lowest: [],
  },
  mutations: {
    setValidation(state, validation) {
      state.setValidation = validation;
    },
    setHomeConteudo(state, homeConteudo) {
      state.homeConteudo = homeConteudo;
    },
    setComoParticiparConteudo(state, comoParticiparConteudo) {
      state.comoParticiparConteudo = comoParticiparConteudo;
    },
    setPesquisaIntes(state, pesquisaItens) {
      state.pesquisaItens = pesquisaItens;
    },
    setTipoNotification(state, tipoNotification) {
      state.tipoNotification = tipoNotification;
    },
    setNotification(state, notification) {
      state.notification = notification;
    },
    setClientes(state, clientes) {
      state.clientes = clientes;
    },
    setCliente(state, cliente) {
      state.cliente = cliente;
    },
    setTipoUsuarios(state, tipoUsuarios) {
      state.tipoUsuarios = tipoUsuarios;
    },
    setTipoMedida(state, tipoMedida) {
      state.tipoMedida = tipoMedida;
    },
    setTipoMedidas(state, tipoMedidas) {
      state.tipoMedidas = tipoMedidas;
    },
    setTipoProfissoes(state, tipoProfissoes) {
      state.tipoProfissoes = tipoProfissoes;
    },
    setTipoProfissao(state, tipoProfissao) {
      state.tipoProfissao = tipoProfissao;
    },
    setEstados(state, estados) {
      state.estados = estados;
    },
    setEstado(state, estado) {
      state.estado = estado;
    },
    setCidades(state, cidades) {
      state.cidades = cidades;
    },
    setCidade(state, cidade) {
      state.cidade = cidade;
    },
    setProduto(state, produto) {
      state.produto = produto;
    },
    setProdutos(state, produtos) {
      state.produtos = produtos;
    },
    setProdutoMarca(state, produtoMarca) {
      state.produtoMarca = produtoMarca;
    },
    setProdutoMarcas(state, produtoMarcas) {
      state.produtoMarcas = produtoMarcas;
    },
    setCategoriasProduto(state, categoriasProduto) {
      state.categoriasProduto = categoriasProduto;
    },
    setCotacoes(state, cotacoes) {
      state.cotacoes = cotacoes;
    },
    setFaturas(state, faturas) {
      state.faturas = faturas;
    },
    setInvoices(state, invoices) {
      state.invoices = invoices;
    },
    setCotacoesSingleEnviadas(state, cotacoesSingleEnviadas) {
      state.cotacoesSingleEnviadas = cotacoesSingleEnviadas;
    },
    setCotacoesSingleGanhas(state, cotacoesSingleGanhas) {
      state.cotacoesSingleGanhas = cotacoesSingleGanhas;
    },
    setCotacoesSingleFinalizadas(state, cotacoesSingleFinalizadas) {
      state.cotacoesSingleFinalizadas = cotacoesSingleFinalizadas;
    },
    setCotacoesSingleCanceladas(state, cotacoesSingleCancelar) {
      state.cotacoesSingleCancelar = cotacoesSingleCancelar;
    },
    setCotacao(state, cotacao) {
      state.cotacao = cotacao;
    },
    setCotacoesContagem(state, cotacoesContagem) {
      state.cotacoesContagem = cotacoesContagem;
    },
    setMensagensCotacao(state, mensagensCotacao) {
      state.mensagensCotacao = mensagensCotacao;
    },
    setToken(state, token) {
      state.token = token;
    },
    setDadosUsuario(state, dadosUsuario) {
      state.dadosUsuario = dadosUsuario;
    },
    setProfissionaisDestaques(state, profissionaisDestaques) {
      state.profissionaisDestaques = profissionaisDestaques;
    },
    setProfissionais(state, profissionais) {
      state.profissionais = profissionais;
    },
    setProfissional(state, profissional) {
      state.profissional = profissional;
    },
    setLojistas(state, lojistas) {
      state.lojistas = lojistas;
    },
    setLojista(state, lojista) {
      state.lojista = lojista;
    },
    setRepresentantes(state, representantes) {
      state.representantes = representantes;
    },
    setRepresentante(state, representante) {
      state.representante = representante;
    },
    setDicas(state, dicas) {
      state.dicas = dicas;
    },
    setDica(state, dica) {
      state.dica = dica;
    },
    setInformacaoUpload(state, informacaoUpload) {
      state.informacaoUpload = informacaoUpload;
    },
    setContratosProfissionais(state, contratosProfissionais) {
      state.contratosProfissionais = contratosProfissionais;
    },
    setContratoProfissional(state, contratoProfissional) {
      state.contratoProfissional = contratoProfissional;
    },
    setCotacoesAdministrador(state, cotacoesAdministrador) {
      state.cotacoesAdministrador = cotacoesAdministrador;
    },
    setPlanos(state, planos) {
      state.planos = planos;
    },
    setPlano(state, plano) {
      state.plano = plano;
    },
    setSegmentos(state, segmentos) {
      state.segmentos = segmentos;
    },
    setSegmento(state, segmento) {
      state.segmento = segmento;
    },
    setBanners(state, banners) {
      state.banners = banners;
    },
    setBanner(state, banner) {
      state.banner = banner;
    },
    setUsuarios(state, usuarios) {
      state.usuarios = usuarios;
    },
    setUsuario(state, usuario) {
      state.usuario = usuario;
    },
    setProfessionalPlans(state, professionalPlansData) {
      state.professionalPlans = professionalPlansData;
    },
    setLowestPrice(state, lowest) {
      state.lowest = lowest;
    },
    setShowContact(state, showContact) {
      state.showContact = showContact;
    },
  },
  getters: {
    getBaseUri: (state) => state.baseURI,
    getToken: (state) => state.token,
    getLowest: (state) => state.lowest,
    getNotification: (state) => state.notification,
    getTipoNotification: (state) => state.tipoNotification,
    getInformacaoUpload: (state) => state.informacaoUpload,
    getLoaderAction: (state) => state.loaderAction,
  },
  actions: {
    checkIsEmpty(value) {
      if (value === '' && value === null && value === 'undefined') {
        return true;
      }
      return false;
    },
    startLoader({ state }) {
      state.loaderAction = true;
    },
    endLoader({ state }) {
      state.loaderAction = false;
    },
    emptyCotacoes({ commit }) {
      commit('setCotacoes', []);
    },
    emptyCotacao({ commit }) {
      commit('setCotacao', null);
    },
    emptyDicas({ commit }) {
      commit('setDicas', null);
    },
    emptyProfissionais({ commit }) {
      commit('setProfissionais', []);
    },
    emptyProfissionaisDestaques({ commit }) {
      commit('setProfissionaisDestaques', []);
    },
    emptyProfissional({ commit }) {
      commit('setProfissional', null);
    },
    emptyUsuarios({ commit }) {
      commit('setUsuarios', []);
    },
    emptyUsuario({ commit }) {
      commit('setUsuario', null);
    },
    emptyLojista({ commit }) {
      commit('setLojista', null);
    },
    loadToken({ commit }) {
      commit('setToken', localStorage.getItem('token'));
    },
    async loadLogin({ commit, dispatch }, value) {
      await api
        .post(`${baseURI}login`, value, {
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json',
          },
        })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);

          if (data.data.info && data.data.token) {
            commit('user/setUserId', data.data.info.id || 0);
            commit('user/setUserType', data.data.info.tipo_usuario_id || 0);

            commit('setDadosUsuario', data.data.info);
            commit('setToken', data.data.token);
            localStorage.setItem(
              'dadosUsuario',
              JSON.stringify(data.data.info)
            );
            localStorage.setItem('token', data.data.token);
          }
        });
    },
    searchClerks({}, data) {
      return api.post('search-clerks', data);
    },
    registrarToken({ commit }, value) {
      localStorage.setItem('token', value);
      commit('setToken', value);
    },
    registrarDadosUsuario({ commit }, value) {
      localStorage.setItem('dadosUsuario', value);
      commit('setDadosUsuario', value);
    },
    exitLogin({ commit }) {
      localStorage.setItem('token', null);
      commit('setToken', localStorage.getItem('token'));
      localStorage.setItem('dadosUsuario', null);
      commit('setDadosUsuario', localStorage.getItem('dadosUsuario'));
    },
    loadTipoUsuarios({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}tipo-usuarios`,
        headers: {},
      })
        .then((r) => r.data)
        .then((tipoUsuarios) => {
          commit('setTipoUsuarios', tipoUsuarios.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadTipoMedidas({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}tipo-medidas`,
        headers: {},
      })
        .then((r) => r.data)
        .then((tipoMedidas) => {
          commit('setTipoMedidas', tipoMedidas.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadTipoProfissoes({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}tipo-profissoes`,
        headers: {},
      })
        .then((r) => r.data)
        .then((tipoProfissoes) => {
          commit('setTipoProfissoes', tipoProfissoes.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadEstados({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}estados`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((estados) => {
          commit('setEstados', estados.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadCidades({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}cidades`,
        headers: {},
      })
        .then((r) => r.data)
        .then((cidades) => {
          commit('setCidades', cidades.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadSegmentos({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}segmentos-all`,
        headers: {},
      })
        .then((r) => r.data)
        .then((segmentos) => {
          commit('setSegmentos', segmentos.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadPlanos({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}planos`,
        headers: {},
      })
        .then((r) => r.data)
        .then((planos) => {
          commit('setPlanos', planos.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadPlanosProfissional({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}planos-profissional`,
        headers: {},
      })
        .then((r) => r.data)
        .then((planos) => {
          commit('setPlanos', planos.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadProdutos({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}produtos`,
        headers: {},
      })
        .then((r) => r.data)
        .then((produtos) => {
          commit('setProdutos', produtos.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadProdutoMarcas({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}produto-marcas`,
        headers: {},
      })
        .then((r) => r.data)
        .then((produtoMarcas) => {
          commit('setProdutoMarcas', produtoMarcas.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadCategoriasProduto({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}produto-categorias`,
        headers: {},
      })
        .then((r) => r.data)
        .then((categoriasProduto) => {
          commit('setCategoriasProduto', categoriasProduto.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadPaginaInicioConteudo({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}conteudo-pagina-inicio`,
        headers: {},
      })
        .then((r) => r.data)
        .then((homeConteudo) => {
          commit('setHomeConteudo', homeConteudo.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    loadPaginaComoParticiparConteudo({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}conteudo-pagina-como-participar`,
        headers: {},
      })
        .then((r) => r.data)
        .then((comoParticiparConteudo) => {
          commit('setComoParticiparConteudo', comoParticiparConteudo.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    searchCotacoesTipoUsuario({ state, commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}cotacoes-tipo-usuario/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((cotacoes) => {
          commit('setCotacoes', cotacoes.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showCotacoesUsuarioRejeitadasEx({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-rejeitadas-ex/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showClientes({ state, commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}clientes`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((clientes) => {
          commit('setClientes', clientes.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showCliente({ state, commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}cliente/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((cliente) => {
          commit('setCliente', cliente.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showTipoMedida({ state, commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}tipo-medida/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((tipoMedida) => {
          commit('setTipoMedida', tipoMedida.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showProfissionaisGeral({ state, commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}profissionais-geral`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((profissionais) => {
          commit('setProfissionais', profissionais.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showProfissionaisPendentes({ state, commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}profissionais-pendentes`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((profissionais) => {
          commit('setProfissionais', profissionais.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showProfissionaisBasicos({ state, commit, dispatch }) {
      // Action utilizada para ver todos os profissionais em geral
      api({
        method: 'get',
        url: `${baseURI}profissionais-basicos`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((profissionais) => {
          commit('setProfissionais', profissionais.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showDiamondProfessionals({ state, commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}diamond-professionals`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((profissionais) => {
          commit('setProfissionais', profissionais.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showProfissionaisDestaquesGeral({ state, commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}profissionais-destaques-geral`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((profissionais) => {
          commit('setProfissionais', profissionais.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showLojista({ state, commit, dispatch }, value) {
      // Action utilizada para ver o lojista
      api({
        method: 'get',
        url: `${baseURI}lojista/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((lojista) => {
          commit('setLojista', lojista.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showLojistas({ state, commit, dispatch }, { segmento_id, cidade_id }) {
      // Action utilizada para ver todos os lojistas
      api({
        method: 'get',
        url: `${baseURI}lojistas`,
        params: {
          segmento_id,
          cidade_id,
        },
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((lojistas) => {
          commit('setLojistas', lojistas.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showRepresentante({ state, commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}representante/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((representante) => {
          commit('setRepresentante', representante.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showRepresentantes({ state, commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}representantes`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((representantes) => {
          commit('setRepresentantes', representantes.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showUsuariosGeral({ state, commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}usuarios`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((usuarios) => {
          commit('setUsuarios', usuarios.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showCotacoesGeral({ state, commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}cotacoes-geral`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((cotacoes) => {
          commit('setCotacoes', cotacoes.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showCotacoesRecebidas({ state, commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}cotacoes-recebidas/${value.tipoId}/${value.usuarioId}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((cotacoes) => {
          commit('setCotacoes', cotacoes.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    // ================================================================================================
    showCotacoesAdm({ state, commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}cotacoes-recebidas/${value.type}/${value.id}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((cotacoes) => {
          commit('setCotacoes', cotacoes.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    // =================================================================================================
    showCotacoesUsuarioSolicitadas({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-solicitadas/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioRespondidas({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-respondidas/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioRespondidasV2({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-respondidas-v2/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioRespondidasCompras({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-respondidas-lojista-compra/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioRespondidasComprasV2(
      { state, commit, dispatch },
      value
    ) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-respondidas-lojista-compra-v2/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioRespondidasVendas({ state, commit, dispatch }, value) {
      // Action utilizada para chamar todas as cotações de vendas do lojista
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-respondidas-lojista-venda/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioAguardando({ state }, value) {
      // Action utilizada para chamar todas as cotações aprovadas por esse usuario
      return api({
        method: 'get',
        url: `${baseURI}cotacoes-aguardando-cliente/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      });
    },
    showCotacoesUsuarioAguardandoPagamento({ state }, value) {
      // Action utilizada para chamar todas as cotações aprovadas por esse usuario
      return api({
        method: 'get',
        url: `${baseURI}cotacoes-aguardando-pagamento-cliente/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      });
    },
    showQuotesCanceled({ state }) {
      // Action utilizada para chamar todas as cotações aprovadas por esse usuario
      return api({
        method: 'get',
        url: `${baseURI}/admin/quote-canceled`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      });
    },
    sendCanceledPayment({ state }, value) {
      console.log(value);
      // Action utilizada para chamar todas as cotações aprovadas por esse usuario
      return api({
        method: 'get',
        url: `${baseURI}/admin/quote-payment-canceled/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      });
    },
    showCotacoesUsuarioAprovadas({ state, commit, dispatch }, value) {
      // Action utilizada para chamar todas as cotações aprovadas por esse usuario
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-aprovadas/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioAprovadasCompras({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-aprovadas-lojista-compra/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioAprovadasVendas({ state, commit, dispatch }, value) {
      // Action utilizada para chamar todas as cotações aprovadas de vendas do lojista
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-aprovadas-lojista-venda/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioAguardandoAprovacaoLojista(
      { state, commit, dispatch },
      value
    ) {
      // Action utilizada para chamar todas as cotações aprovadas de vendas do lojista
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-aguardando-aprovacao-lojista/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    sendTokenValidQuote({ rootGetters }, data) {
      return api.post('valid-token-payment', data, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    createSubAccount({ rootGetters }, value) {
      return api.post('payment/split/create', value, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    updateSubAcoount({ rootGetters }, value) {
      return api.put(`payment/split/updateSubAccount`, value, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    showCheckout({ rootGetters }, value) {
      return api.get(`payment/invoice/${value.id}/${value.shop}`, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    alterStatusPayment({ rootGetters }, value) {
      return api.get(`/alter-payment/invoice/${value.id}`, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    showCheckoutCancel({ rootGetters }, id) {
      return api.get(`get-cancel/payment/invoice/${id}`, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    withdrawAccount({ rootGetters }, value) {
      return api.post('payment/split/withdraw', value, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    showInfoDashboard({ rootGetters }) {
      return api.get('payment/split/infoSubAccount', {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    saveBankShop({ rootGetters }, data) {
      return api.post('payment/split/save-bank', data, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    listTransferIugu({ rootGetters }, id) {
      return api.get(`payment/split/list-transfer/${id}`, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    
    // wallet
    transferIuguAccount({ rootGetters }, data) {
      return api.post('payment/wallet/transfer', data, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    
    invoiceWalletIugu({ rootGetters }, data) {
      return api.post('payment/wallet/invoice', data, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    
    paymentWalletIugu({ rootGetters }, data) {
      return api.post('payment/wallet/create', data, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    
   


    // !=============================================================
    showInfoDashboardAdmin({ rootGetters }, id) {
      return api.get(`payment/split/infoSubAccountAdmin/${id}`, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    sendCc({ rootGetters }, value) {
      return api.post('payment/invoice/direct', value, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    buscarDadosAssinatura({}, id) {
      return api.get(`buscar-dados-assinatura/${id}`);
    },
    buscarAssinaturaProfissional({}, id) {
      return api.get(`buscar-assinatura-profissional/${id}`);
    },
    addGerenteContaUser({}, data) {
      return api.post('add-gerente-conta', data);
    },
    sendValidation({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'post',
          url: `${baseURI}payment/split/sendValidationSubAccount`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
          data: {
            value,
          },
        })
          .then((r) => r.data)
          .then((validation) => {
            commit('setValidation', validation.data);
          });
      }
    },
    postCheckout({ rootGetters }, value) {
      return api.post('payment/invoice/create', value, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    showCotacoesUsuarioFinalizadas({ state, commit, dispatch }, value) {
      // Action utilizada para chamar todas as cotações aprovadas por esse usuario
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-finalizadas/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioFinalizadasCompras({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-finalizadas-lojista-compra/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioFinalizadasVendas({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-finalizadas-lojista-venda/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioRejeitadas({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-rejeitadas/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioRejeitadasLoCli({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-rejeitadas-lojista-de-cliente/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioRejeitadasLoRe({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-rejeitadas-lojista-de-representante/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioRejeitadasCom({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-rejeitadas-com/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioRejeitadasVen({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-rejeitadas-ven/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioPerdidas({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-perdidas/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioFinalizadasWithTime({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-finalizadas-com-tempo/${value.id}/${value.mes}/${value.ano}/`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioEnviadasVendasWithTime(
      { state, commit, dispatch },
      value
    ) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'post',
          url: `${baseURI}cotacoes-enviadas-lojista-venda-com-tempo`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
          data: {
            value,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoesSingleEnviadas', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioGanhasVendasWithTime(
      { state, commit, dispatch },
      value
    ) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'post',
          url: `${baseURI}cotacoes-ganhas-lojista-venda-com-tempo`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
          data: {
            value,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoesSingleGanhas', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioCanceladasVendasWithTime(
      { state, commit, dispatch },
      value
    ) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'post',
          url: `${baseURI}cotacoes-canceladas-lojista-venda-com-tempo`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
          data: {
            value,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoesSingleCanceladas', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioFinalizadasVendasWithTime(
      { state, commit, dispatch },
      value
    ) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'post',
          url: `${baseURI}cotacoes-finalizadas-lojista-venda-com-tempo`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
          data: {
            value,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoesSingleFinalizadas', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioEnviadasAllWithTime({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'post',
          url: `${baseURI}cotacoes-enviadas-todos-usuarios`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
          data: {
            value,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoesSingleEnviadas', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioGanhasAllWithTime({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'post',
          url: `${baseURI}cotacoes-ganhas-todos-usuarios`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
          data: {
            value,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoesSingleGanhas', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioFinalizadasAllWithTime(
      { state, commit, dispatch },
      value
    ) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'post',
          url: `${baseURI}cotacoes-finalizadas-todos-usuarios`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
          data: {
            value,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoesSingleFinalizadas', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioCanceladasAllWithTime(
      { state, commit, dispatch },
      value
    ) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'post',
          url: `${baseURI}cotacoes-canceladas-todos-usuarios`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
          data: {
            value,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            // console.log(cotacoes)
            commit('setCotacoesSingleCanceladas', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuarioGeralAllWithTime({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'post',
          url: `${baseURI}cotacoes-em-geral`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
          data: {
            value,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showContagemCotacoes({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes-contagem/${value.tipo_usuario_id}/${value.id}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoesContagem', cotacoes);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacoesUsuario({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacoes/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacoes) => {
            commit('setCotacoes', cotacoes.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacao({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacao/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacao) => {
            commit('setCotacao', cotacao.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showCotacaoRespondida({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacao-respondida/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacao) => {
            commit('setCotacao', cotacao.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showValueQuote({ state, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        return api({
          method: 'get',
          url: `${baseURI}cotacao-respondida/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        });
      }
    },
    showCotacaoRejeitada({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacao-rejeitada/${value.cot_id}/${value.usu_id}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((cotacao) => {
            commit('setCotacao', cotacao);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showMensagensCotacaoResposta({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacao-resposta-produto-mensagens/${value}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((mensagensCotacao) => {
            commit('setMensagensCotacao', mensagensCotacao.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    showMensagensCotacaoRespostaAtt({ state, commit, dispatch }, value) {
      if (dispatch('checkIsEmpty', value)) {
        api({
          method: 'get',
          url: `${baseURI}cotacao-resposta-produto-mensagens-att/${value.id}/${value.usuarioId}`,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
          .then((r) => r.data)
          .then((mensagensCotacao) => {
            commit('setMensagensCotacao', mensagensCotacao.data);
          })
          .catch(() => {
            dispatch('refreshToken');
          });
      }
    },
    getDiamondProfessionals({ commit, dispatch }, value) {
      let endereco = `${baseURI}profissionais-destaque/${value.pag}`;

      if (value.cidade != null) {
        endereco = `${endereco}/${value.cidade}`;
      } else {
        endereco = `${endereco}/null`;
      }

      if (value.profissao != null) {
        endereco = `${endereco}/${value.profissao}`;
      } else {
        endereco = `${endereco}/null`;
      }

      api({
        method: 'get',
        url: endereco,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((profissionaisDestaques) => {
          commit('setProfissionaisDestaques', profissionaisDestaques);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    getBronzeSilverGoldProfessionals({ commit, dispatch }, value) {
      let endereco = `${baseURI}bronze-silver-gold-professionals/${value.pag}`;

      if (value.cidade != null) {
        endereco = `${endereco}/${value.cidade}`;
      } else {
        endereco = `${endereco}/null`;
      }

      if (value.profissao != null) {
        endereco = `${endereco}/${value.profissao}`;
      } else {
        endereco = `${endereco}/null`;
      }

      api({
        method: 'get',
        url: endereco,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((profissionais) => {
          commit('setProfissionais', profissionais);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showProfissionais({ commit, dispatch }, value) {
      let endereco = `${baseURI}profissionais/${value.pag}`;

      if (value.cidade != null) {
        endereco = `${endereco}/${value.cidade}`;
      } else {
        endereco = `${endereco}/null`;
      }

      if (value.profissao != null) {
        endereco = `${endereco}/${value.profissao}`;
      } else {
        endereco = `${endereco}/null`;
      }

      api({
        method: 'get',
        url: endereco,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((profissionais) => {
          commit('setProfissionais', profissionais);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showProfissional({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}profissional/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((profissional) => {
          commit('setProfissional', profissional.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    saveAssessments({ state }, value) {
      return api.post('save-assessments', value, {
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
    },
    saveReport({ state }, value) {
      return api.post('save-report', value, {
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
    },
    getAssessments({}, id) {
      return api.get(`get-assessments/${id}`);
    },
    showProfissionalRelacionados({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}profissional-relacionados/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((profissionais) => {
          commit('setProfissionais', profissionais.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showDicas({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}blog`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((dicas) => {
          commit('setDicas', dicas);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showAllDicas({ commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}blog/all`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((dicas) => {
          commit('setDicas', dicas);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showDicasRelacionadas({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}dica-obra-relacionadas/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((dicas) => {
          commit('setDicas', dicas.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showDicasPag({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}blog/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((dicas) => {
          commit('setDicas', dicas);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showDica({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}assunto/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((dica) => {
          commit('setDica', dica.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showEstado({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}estado/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((estado) => {
          commit('setEstado', estado.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showCidade({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}cidade/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((cidade) => {
          commit('setCidade', cidade.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showSegmento({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}segmento/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((segmento) => {
          commit('setSegmento', segmento.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showProfissao({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}profissao/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((profissao) => {
          commit('setTipoProfissao', profissao.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    // aqui({ commit, dispatch }, value) {
    //   return api({
    //     method: 'put',
    //     url: `${baseURI}/recuperar-senha`,
    //     headers: {
    //       Accept: 'application/json',
    //       'Content-Type': 'application/json',
    //     },
    //   })
    // },
    showProduto({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}produto/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((produto) => {
          commit('setProduto', produto.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showProdutoMarca({ commit, dispatch }, value) {
      api({
        method: 'get',
        url: `${baseURI}produto-marca/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((produtoMarca) => {
          commit('setProdutoMarca', produtoMarca.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showContratosProfissional({ state, commit, dispatch }, value) {
      api
        .get(`${baseURI}contrato-profissionais`, {
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
        .then((r) => r.data)
        .then((contratos) => {
          commit('setContratosProfissionais', contratos.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showContratoProfissional({ state, commit, dispatch }, value) {
      api
        .get(`${baseURI}contrato-profissional/${value}`, {
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
        .then((r) => r.data)
        .then((contrato) => {
          commit('setContratoProfissional', contrato.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    showCotacoesAdministrador({ state, commit, dispatch }) {
      api
        .get(`${baseURI}cotacoes-administrador`, {
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
        .then((r) => r.data)
        .then((cotacoes) => {
          commit('setCotacoesAdministrador', cotacoes);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },

    showProductBarcode({}, code) {
      return api.get(`product-barcode/${code}`);
    },

    blogShopkeeper({}, id) {
      return api.get(`push-blog/${id}`);
    },

    insertUsuario({ state, commit, dispatch }, value) {
      if (
        value.email !== null &&
        value.password !== null &&
        value.tipo_usuario_id !== null
      ) {
        api({
          method: 'post',
          url: `${baseURI}usuario`,
          headers: {
            Accept: 'application/json',
            'Content-type': 'application/json',
          },
          data: {
            value,
          },
        })
          .then((data) => {
            dispatch('endLoader');
            commit('setNotification', data.data.message);
            commit('setTipoNotification', data.data.tipo);
          })
          .catch((data) => {
            dispatch('refreshToken');
            dispatch('endLoader');
            commit('setNotification', data.data.message);
            commit('setTipoNotification', data.data.tipo);
          });

        setTimeout(() => Promise.resolve(state.notification), 1000);
      }
    },
    insertCotacaoResposta({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}cotacao-resposta`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });

      setTimeout(() => Promise.resolve(state.notification), 1000);
    },
    insertCotacaoRespostaRejeitada({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}cotacao-resposta-rejeicao`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });

      setTimeout(() => Promise.resolve(state.notification), 1000);
    },

    insertCotacaoRespostaRejeitadaLojista({ state }, value) {
      return api({
        method: 'post',
        url: `${baseURI}cotacao-resposta-rejeicao-lojista`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      });
    },

    insertCotacao({ state, commit, dispatch }, value) {
      let infoMessage;
      api({
        method: 'post',
        url: `${baseURI}inserir-cotacao`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
          dispatch('endLoader');
          return Promise.resolve(infoMessage);
        })
        .catch(() => {
          dispatch('refreshToken');
          dispatch('endLoader');
        });
    },
    insertMensagem({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}cotacao-resposta-produto-mensagens`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    insertDicaObra({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}cria-dica-obra`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    insertContrateAqui({ state, commit, dispatch }, value) {
      api
        .post(`${baseURI}contrate-profissional`, value, {
          headers: {
            Accept: '*/*',
            'Content-type': 'application/json',
            Authorization: `Bearer ${state.token}`,
          },
        })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch(() => {
          dispatch('refreshToken');
          dispatch('endLoader');
        });
    },
    insertTipoMedida({ state, commit, dispatch }, value) {
      let info;
      info = api({
        method: 'post',
        url: `${baseURI}cria-tipo-medida`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('endLoader');
          if (data.message === error401) {
            dispatch('refreshToken');
          }
        });
    },
    insertSegmento({ state, commit, dispatch }, value) {
      let info;
      info = api({
        method: 'post',
        url: `${baseURI}cria-segmento`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('endLoader');
          if (data.message === error401) {
            dispatch('refreshToken');
          }
        });
    },
    insertProfissao({ state, commit, dispatch }, value) {
      let info = null;
      info = api({
        method: 'post',
        url: `${baseURI}cria-profissao`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('endLoader');
          if (data.message === error401) {
            dispatch('refreshToken');
          }
        });
    },
    insertEstado({ state, commit, dispatch }, value) {
      let info = null;
      info = api({
        method: 'post',
        url: `${baseURI}cria-estado`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('endLoader');
          if (data.message === error401) {
            dispatch('refreshToken');
          }
        });
    },
    insertCidade({ state, commit, dispatch }, value) {
      let info = null;
      info = api({
        method: 'post',
        url: `${baseURI}cria-cidade`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('endLoader');
          if (data.message === error401) {
            dispatch('refreshToken');
          }
        });
    },
    insertProduto({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}cria-produto`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    insertProdutoMarca({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}cria-produto-marca`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateInicioPaginaConteudo({ state, commit, dispatch }, value) {
      let info = null;
      info = api({
        method: 'post',
        url: `${baseURI}atualiza-conteudo-pagina-inicio`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('endLoader');
          if (data.message === error401) {
            dispatch('refreshToken');
          }
        });
    },
    updatePaginaComoParticiparConteudo({ state, commit, dispatch }, value) {
      let info = null;
      info = api({
        method: 'post',
        url: `${baseURI}atualiza-conteudo-pagina-como-participar`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('endLoader');
          if (data.message === error401) {
            dispatch('refreshToken');
          }
        });
    },
    updateTipoMedidas({ state, commit, dispatch }, value) {
      let info = null;
      info = api({
        method: 'post',
        url: `${baseURI}editar-tipo-medidas`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('endLoader');
          if (data.message === error401) {
            dispatch('refreshToken');
          }
        });
    },
    updateBanner({ state, commit, dispatch }, value) {
      let info = null;
      info = api({
        method: 'post',
        url: `${baseURI}editar-banner`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('endLoader');
          if (data.message === error401) {
            dispatch('refreshToken');
          }
        });
    },
    updateCotacaoRespostaDetalhes({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-detalhes-cotacao-resposta`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateCotacaoResposta({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-cotacao-resposta`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    quoteAprovePayment({ state }, value) {
      api({
        method: 'post',
        url: `${baseURI}inserir-cotacao-payment`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      });
    },
    updateCotacaoAprovacao({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}aprova-cotacao-resposta`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateCotacaoFinalizacao({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}finaliza-cotacao-resposta`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    altertDateDelivery({ state }, value) {
      return api({
        method: 'post',
        url: `${baseURI}alterar-data-entrega`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      });
    },
    cancelamentoPedido({ state }, value) {
      return api({
        method: 'post',
        url: `${baseURI}cancelar-pedido`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      });
    },
    aprovarCotacaoLojista({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}aprova-cotacao-resposta-lojista`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateCotacaoRejeitacao({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}rejeita-cotacao-resposta`,
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateDica({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}edita-dica-obra`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateSegmento({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}edita-segmento`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateProfissao({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}edita-profissao`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateEstado({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}edita-estado`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateCidade({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}edita-cidade`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateProduto({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}edita-produto`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateProdutoMarca({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}edita-produto-marca`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    getNotifications({ state }, value) {
      return api({
        method: 'get',
        url: `${baseURI}atualiza-notificacoes/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      });
    },
    updateNotifications({ state }, value) {
      return api({
        method: 'post',
        url: `${baseURI}atualiza-notificacoes`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      });
    },
    updateCliente({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-cliente`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('refreshToken');
          setTimeout(() => {
            localStorage.setItem(
              'dadosUsuario',
              JSON.stringify(data.data.info[0])
            );
            commit(
              'setDadosUsuario',
              JSON.parse(localStorage.getItem('dadosUsuario'))
            );
            dispatch('endLoader');
          }, 1500);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateProfissional({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-profissional`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('refreshToken');
          setTimeout(() => {
            localStorage.setItem(
              'dadosUsuario',
              JSON.stringify(data.data.info[0])
            );
            commit(
              'setDadosUsuario',
              JSON.parse(localStorage.getItem('dadosUsuario'))
            );
            dispatch('endLoader');
          }, 1500);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateProfissionalPerfil({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-perfil-profissional`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('refreshToken');
          setTimeout(() => {
            localStorage.setItem(
              'dadosUsuario',
              JSON.stringify(data.data.info[0])
            );
            commit(
              'setDadosUsuario',
              JSON.parse(localStorage.getItem('dadosUsuario'))
            );
            dispatch('endLoader');
          }, 1500);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateLojista({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-lojista`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('refreshToken');
          setTimeout(() => {
            localStorage.setItem(
              'dadosUsuario',
              JSON.stringify(data.data.info[0])
            );
            commit(
              'setDadosUsuario',
              JSON.parse(localStorage.getItem('dadosUsuario'))
            );
            dispatch('endLoader');
          }, 1500);
        })
        .catch(() => {});
    },
    updateRepresentante({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-representante`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('refreshToken');
          setTimeout(() => {
            localStorage.setItem(
              'dadosUsuario',
              JSON.stringify(data.data.info[0])
            );
            commit(
              'setDadosUsuario',
              JSON.parse(localStorage.getItem('dadosUsuario'))
            );
            dispatch('endLoader');
          }, 1500);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    submitWhatsapp({ rootGetters }, value) {
      return api.post('admin/whatsapp', value, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
    updateAdministrador({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-administrador`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
          commit('setDadosUsuario', data.data.info[0]);
          localStorage.setItem('dadosUsuario', data.data.info[0]);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateClienteByAdm({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-cliente`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateProfissionalByAdm({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-profissional`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateLojistaByAdm({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-lojista`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateRepresentanteByAdm({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualiza-representante`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteCotacao({ state, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-cotacao/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then(() => {
          dispatch('endLoader');
        })
        .catch(() => {
          dispatch('refreshToken');
          dispatch('endLoader');
        });
    },
    deleteUsuario({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-usuario/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteDica({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-dica-obra`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteTipoMedida({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-tipo-medida`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteBanner({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-banner`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteSegmento({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-segmento`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteProfissao({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-profissao`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteEstado({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-estado`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteCidade({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-cidade`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteProduto({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-produto`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteProdutoMarca({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-produto-marca`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    deleteTrabalhoProfissional({ state, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-trabalho/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then(() => {
          dispatch('endLoader');
        })
        .catch(() => {
          dispatch('refreshToken');
          dispatch('endLoader');
        });
    },
    updateProfissoesProfissional({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualizar-profissoes-profissional`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateCidadesProfissional({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualizar-cidades-profissional`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateLinksProfissional({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualizar-links-profissional`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateTrabalhosProfissional({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}atualizar-trabalhos-profissional`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data: {
          value,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateContratoProfissionalBasico({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}contrato-profissional-basico-aceito/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateContratoProfissionalDestaque({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}contrato-profissional-destaque-aceito/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },
    updateSegmentosLojista({ state, commit, dispatch }, data) {
      api({
        method: 'post',
        url: `${baseURI}atualizar-segmentos-lojistas`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data,
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setDadosUsuario', data.data.data[0]);
          localStorage.setItem('dadosUsuario', data.data.data[0]);
        })
        .catch(() => {
          dispatch('refreshToken');
          dispatch('endLoader');
        });
    },
    updateSegmentosRepresentante({ state, commit, dispatch }, data) {
      api({
        method: 'post',
        url: `${baseURI}atualizar-segmentos-representantes`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data,
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setDadosUsuario', data.data.data[0]);
          localStorage.setItem('dadosUsuario', data.data.data[0]);
        })
        .catch(() => {
          dispatch('refreshToken');
          dispatch('endLoader');
        });
    },
    sendMailNewsletter({ dispatch }, data) {
      api({
        method: 'post',
        url: `${baseURI}receive-newsletter`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data,
      }).catch(() => {
        dispatch('refreshToken');
      });
    },
    sendContactEmail({}, data) {
      return api.post('/contact-us', data);
    },
    sendMailRecuperarSenha({ commit, dispatch }, value) {
      let data;
      data = {
        info: value,
      };

      api({
        method: 'post',
        url: `${baseURI}recuperar-senha`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data,
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
          commit('setDadosUsuario', data.data.info[0]);
        })
        .catch(() => {
          dispatch('endLoader');
        });
    },
    searchData({ commit, dispatch }, data) {
      api({
        method: 'post',
        url: `${baseURI}pesquisar/${data}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((pesquisa) => {
          commit('setPesquisaIntes', pesquisa.data);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },
    refreshToken({ state, commit }) {
      api({
        method: 'post',
        url: `${baseURI}refresh-token`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      }).then((data) => {
        commit('setToken', data.data.token);
        localStorage.setItem('token', data.data.token);
      });
    },
    loadProfessionalPlans({ state, commit }) {
      api({
        method: 'get',
        url: `${baseURI}professional-plans`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      }).then((response) => {
        commit('setProfessionalPlans', response.data.data);
      });
    },
    async updateProfessionalPlan({ state, commit }, data) {
      await api({
        method: 'PUT',
        url: `${baseURI}update-plan/${data.id}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data,
      })
        .then((response) => {
          commit('setNotification', response.data.msg);
        })
        .catch((error) => {
          commit('setNotification', error.data.msg);
        });
    },

    async getClientPrice({ state, commit }, value) {
      await api({
        method: 'GET',
        url: `${baseURI}lowest-price-city/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((response) => {
          commit('setLowestPrice', response.data);
        })
        .catch((error) => {
          commit('setLowestPrice', error.data.msg);
        });
    },

    insertShopkeeperPrice({ state, commit }, data) {
      return api({
        method: 'POST',
        url: `${baseURI}lowest-price`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        data,
      });
    },
    // insertShopkeeperPrice({ state, commit }, data) {
    //   return api({
    //     method: 'GET',
    //     url: `${baseURI}recupera-senha/${data}`,
    //     headers: {
    //       Accept: 'application/json',
    //       'Content-Type': 'application/json',
    //       Authorization: `Bearer ${state.token}`,
    //     },
    //     data
    //   })
    // },
    getShopkeeperPrice({ state, commit }, id) {
      return api({
        method: 'GET',
        url: `${baseURI}lowest-price/${id}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
        id,
      });
    },
    aqui({}, data) {
      return api({
        method: 'POST',
        url: `${baseURI}modificar-senha`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data,
      });
    },

    addOneView({}, pId) {
      api({
        method: 'post',
        url: `${baseURI}add-one-view/${pId}`,
      });
    },

    lojistaSolicitaApp({ rootGetters }, data) {
      api({
        method: 'post',
        url: `${baseURI}app/lojista/solicita`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
        data,
      });
    },
    profissionalSolicitaSite({ rootGetters }, data) {
      api({
        method: 'post',
        url: `${baseURI}site/profissional/solicita`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
        data,
      });
    },

    validarContaIugu({ rootGetters }, id) {
      return api.get('app/lojista/valida-iugu/'+id, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },

    verificaSolicitacao({ rootGetters }, value) {
      return api.post('app/lojista/verifica', value, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },

    sendShopkeeperData({}, data) {
      api({
        method: 'post',
        url: `${baseURI}create-req`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data,
      });
    },

    showShopkeepertData({ state }) {
      return api({
        method: 'get',
        url: `${baseURI}show-app`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
    },

    sendRequestData({}, data) {
      api({
        method: 'post',
        url: `${baseURI}datacontact`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data,
      });
    },

    sendProductData({}, data) {
      api({
        method: 'post',
        url: `${baseURI}dataproduct`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        data,
      });
    },

    gettingAllSuggestProducts({ rootGetters }) {
      return api.get(`/get-products`, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },

    deleteProduct({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-product/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
      .then((data) => {
        dispatch('endLoader');
        commit('setShowContact', data.data.message);
        commit('setShowContact', data.data.tipo);
      })
      .catch((data) => {
        dispatch('refreshToken');
        dispatch('endLoader');
        commit('setNotification', data.data.message);
        commit('setTipoNotification', data.data.tipo);
      });
    },

    showContact({ state, commit, dispatch }) {
      api({
        method: 'get',
        url: `${baseURI}contact-admin`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((r) => r.data)
        .then((showContact) => {
          commit('setShowContact', showContact);
        })
        .catch(() => {
          dispatch('refreshToken');
        });
    },

    listarSolicitacaoApp({ state }) {
      return api({
        method: 'get',
        url: `${baseURI}app/adm/listarNovos`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
    },

    deleteContact({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}/datacontact/delete-client/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        }
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setShowContact', data.data.message);
          commit('setShowContact', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },

    listarTodasSolicitacoesApp({ state }, data ) {
      return api({
        method: 'get',
        url: `${baseURI}app/adm/listarTodos?status=${data.status}&startDate=${data.startDate}&endDate=${data.endDate}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
    },

    listarTodasSolicitacoesSite({ state }, data ) {
      return api({
        method: 'get',
        url: `${baseURI}site/adm/listar-todos?status=${data.status}&startDate=${data.startDate}&endDate=${data.endDate}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
    },

    deleteUsuario({ state, commit, dispatch }, value) {
      api({
        method: 'post',
        url: `${baseURI}delete-usuario/${value}`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.token}`,
        },
      })
        .then((data) => {
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        })
        .catch((data) => {
          dispatch('refreshToken');
          dispatch('endLoader');
          commit('setNotification', data.data.message);
          commit('setTipoNotification', data.data.tipo);
        });
    },

    updateShopkeeperStatus({rootGetters}, data) {
      return api.post(`app/adm/editar/${data.id}`, data,{
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`
        },
      })
    },

    updateProfissionalStatus({rootGetters}, data) {
      return api.post(`site/adm/editar/${data.id}`, data,{
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`
        },
      })
    },

    alterarAssinaturaPagamento({rootGetters}, data) {
      return api.post('editar/assinatura-lojista', data,{
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`
        },
      })
    },

    getAppShopkeeperById({ rootGetters }, id) {
      return api.get(`app/lojista/verificaId/${id}`, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
    },
  },
});
